import {
  observable,
  action,
  decorate,
  configure,
  toJS,
  runInAction,
} from 'mobx';
import reducer from './reducers/engineTools';
import { loadData } from './utils';
configure({ enforceActions: 'always' });

const missingEngineToolParameter = 'engineToolType parameter is required';

class EngineToolStore {
  constructor() {
    runInAction(() => {
      this.data = [];
      this.postData = null;
      this.totalItems = 0;
      this.widgetReloading = {};
    });
  }

  setProperty = (key, value) => {
    this[key] = value;
  };

  getProperty = (key) => {
    return this[key];
  };

  setLoading = (key, value) => (this.widgetReloading[key] = value);

  finalizeResults = (data, engineToolType) => {
    this.setProperty('data', toJS(data));
    this.setProperty('totalItems', data?.length);
    this.setLoading(engineToolType, false);
    return data;
  };

  engineFetch = async (engineToolType, args = {}) => {
    if (!engineToolType) throw new ReferenceError(missingEngineToolParameter);
    this.setLoading(engineToolType, true);
    const { fn, body, processData } = reducer(engineToolType);
    return loadData({ ...body, ...args }, fn)
      .then(processData)
      .then((data) => this.finalizeResults(data, engineToolType));
  };

  enginePost = async (engineToolType, args = {}) => {
    if (!engineToolType) throw new ReferenceError(missingEngineToolParameter);
    this.setLoading(engineToolType, true);
    const { fn, body, processData } = reducer(engineToolType);
    return loadData({ ...body, ...args }, fn)
      .then(processData)
      .then((res) => {
        this.setLoading(engineToolType, false);
        return res;
      });
  };
}

decorate(EngineToolStore, {
  data: observable,
  engineFetch: action,
  enginePost: action,
  finalizeResults: action,
  getProperty: action,
  initializeMembersList: action,
  postData: observable,
  reducer: action,
  setLoading: action,
  setProperty: action,
  totalItems: observable,
  widgetReloading: observable,
});

export default EngineToolStore;
